var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DocumentsTable'),(_vm.showDocumentDetail)?_c('DocumentDetail',{attrs:{"webkey":_vm.showDocumentWebkey,"selection":_vm.selection},on:{"close":_vm.closeDocumentDetail}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }